<template>
    <div>
    <!-- CONTENIDO PRINCIPAL -->
    <div :class="alto_contenido()">
        <div class="container contenido_principal">
            <!-- ===Apartado de las cards=== -->
            <div class="seccion_cardsOpciones my-2">
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'comiteEticaPrevencionCI'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <!---Imagen de la card-->
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="fas fa-book-reader icono_card"></i>
                                    </div>
                                    <!---Texto de la card-->
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Comité de Ética y de Prevención de Conflictos de Interés</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>  
                    </div>



                    <!-- <div class="col-xs-12 col-sm-6 col-md-6">
                        <a :href="urlServe+'conocenos/informacion/convocatoria/consejeros.pdf'" target="_blank" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-book icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-0">Convocatoria para desempeñarse como consejeros y consejeras del Comité de Ética y Prevención de Conflictos de Interés</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>           -->
                </div>

                <div class="w-100 p-5 m-5"></div>

                <!-- <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <a target="_blank" class="nav-link" :href="urlServe+ 'conocenos/informacion/codigo/codigo.pdf'">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-tasks icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Código de Honestidad y Ética de los Servidores Públicos de la Administración Pública del Estado de Chiapas</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <a target="_blank" class="nav-link" :href="urlServe+'conocenos/informacion/codigo/codigo-SH.pdf'">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="far fa-file-alt icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Código de Conducta de la Secretaría de Hacienda</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div> -->
                <!-- <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <a target="_blank" :href="urlServe+'conocenos/informacion/cero-tolerancia/cero-tolerancia.pdf'" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="fas fa-building icono_card"></i>
                                    </div>
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Pronunciamiento de “Cero Tolerancia” al hostigamiento sexual y acoso sexual en la Secretaría de Hacienda del Estado de Chiapas</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <a target="_blank" :href="urlServe+'marco-juridico/Estatal/informacion/Protocolos/acoso-sexual.pdf'" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-chart-line icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Protocolo para la prevención, atención y sanción del hostigamiento sexual y acoso sexual</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div> -->
                <!-- <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <a target="_blank" :href="urlServe+'marco-juridico/Estatal/informacion/Protocolos/discriminacion.pdf'"  class="nav-link">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-sitemap icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Protocolo de actuación de los Comités de Ética y de Prevención de Conflictos de Interés en la atención de presuntos actos de discriminación </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>                         -->
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    methods:{
        alto_contenido(){
            if(screen.width > 1366)  return 'pantalla_grande' 
        }
    }
}
</script>
